<script setup lang="ts">
import { Ref } from "vue";
import { Hint } from "../../types";
const props = defineProps<{
  state?: Ref<boolean>,
  hint?: Hint
}>();

const start = (e: Element) => {
  const item = e as HTMLElement;
  item.style.height = item.scrollHeight + "px";
};

const end = (e: Element) => {
  const item = e as HTMLElement;
  item.style.height = "0px";
};

</script>

<template>
  <transition name="accordion" @enter="start" @before-leave="start" @after-leave="end">
    <div 
      v-show="state?.value" class="body" 
      :class="state?.value? '': 'body-active'" style="height: 0"
    >
      <slot />
    </div>
  </transition>
</template>

<style scoped lang="scss">
.body {
  gap: 12px;
  display: flex;
  padding: 0 40px;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    padding: 0 20px;
    border-radius: 24px;
  }
}



.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease;
  will-change: height, opacity;
}

.accordion-enter-from,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
